// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_fA","advertDetailService__price":"c-n_fB"};